
	<template>
		<div class="content">


				<table>
					<tr> 
						<td style="width: 100%;"></td>
				        	<td style="width: 150px;">
				      			<base-button class="btn btn-primary" @click="updateName()">Save</base-button>
				        	</td>
				        	<td style="width: 150px;">
				        	<td style="width: 150px;">
				        		
								<div >
								  <div class="container">
												    <base-button class="btn btn-primary" @click="modal2Names = true">Add</base-button>
								              <modal :show.sync="modal2Names">
								                <template slot="header">
								                  <h5 class="modal-title" id="exampleModalLabel">Add Name</h5>
								                </template>
								                <div>
								                  <form @submit.prevent>
								  <base-input label="Snake" type="text" placeholder="Enter Snake" v-model="nameToAdd.snake"></base-input>
												                  </form>
								                </div>
								                <template slot="footer">
								                  <base-button type="primary" @click="handleAddSubmitted()">Save</base-button>
								                </template>
								              </modal>
												  </div>
								</div>
				        	</td>
					</tr> 
				</table>



				<table>
      <template>
        <div class="content">
          <a-modal :footer="null" :visible="showProgressBar" class="centered-modal" v-if="showProgressBar"
                   :closable="false">
            <div style="text-align: center; padding: 20px;">
              <h5>Please wait...</h5>
            </div>
          </a-modal>
        </div>
        <div class="content">
          <a-modal :footer="null" :visible="userPermissionDialog" :closable="false" class="centered-modal" v-if="userPermissionDialog">
            <div style="text-align: center; padding: 20px;">
              <h5>User does not have permission</h5>
              <button @click="handlePermissionDialogClose">OK</button>
            </div>
          </a-modal>
        </div>
      </template>

	
		<tr> 
			<td class="detail_view_column_1"></td>
			<td class="detail_view_column_2"></td>
			<td rowspan="50" style="vertical-align: top;">
				<br><base-button class="btn btn-primary btn_apps" @click="updateNameFromSnake()">Update From Snake</base-button>
			</td>
		</tr> 
	
	
		
		
										<tr> 
					<td class="detail_view_column_2">Name Id</td>
																							    		<td class="detail_view_column_1"><b> {{ nameDetails.nameId }} </b></td>
					    						    														</tr>
															<tr> 
					<td class="detail_view_column_2">Snake</td>
										    <td class="detail_view_column_1">
							<div class="detail_view_input" style="display: inline-flex;">
																		<input label="Snake" type="text" placeholder="Enter Snake" v-model="nameDetails.snake"></input>
																		</div>
						</td>
														</tr>
															<tr> 
					<td class="detail_view_column_2">Snake Plural</td>
										    <td class="detail_view_column_1">
							<div class="detail_view_input" style="display: inline-flex;">
																		<input label="SnakePlural" type="text" placeholder="Enter SnakePlural" v-model="nameDetails.snakePlural"></input>
																		</div>
						</td>
														</tr>
															<tr> 
					<td class="detail_view_column_2">Camel</td>
										    <td class="detail_view_column_1">
							<div class="detail_view_input" style="display: inline-flex;">
																		<input label="Camel" type="text" placeholder="Enter Camel" v-model="nameDetails.camel"></input>
																		</div>
						</td>
														</tr>
															<tr> 
					<td class="detail_view_column_2">Camel Plural</td>
										    <td class="detail_view_column_1">
							<div class="detail_view_input" style="display: inline-flex;">
																		<input label="CamelPlural" type="text" placeholder="Enter CamelPlural" v-model="nameDetails.camelPlural"></input>
																		</div>
						</td>
														</tr>
															<tr> 
					<td class="detail_view_column_2">Pascal</td>
										    <td class="detail_view_column_1">
							<div class="detail_view_input" style="display: inline-flex;">
																		<input label="Pascal" type="text" placeholder="Enter Pascal" v-model="nameDetails.pascal"></input>
																		</div>
						</td>
														</tr>
															<tr> 
					<td class="detail_view_column_2">Pascal Plural</td>
										    <td class="detail_view_column_1">
							<div class="detail_view_input" style="display: inline-flex;">
																		<input label="PascalPlural" type="text" placeholder="Enter PascalPlural" v-model="nameDetails.pascalPlural"></input>
																		</div>
						</td>
														</tr>
															<tr> 
					<td class="detail_view_column_2">Snake Dash</td>
										    <td class="detail_view_column_1">
							<div class="detail_view_input" style="display: inline-flex;">
																		<input label="SnakeDash" type="text" placeholder="Enter SnakeDash" v-model="nameDetails.snakeDash"></input>
																		</div>
						</td>
														</tr>
															<tr> 
					<td class="detail_view_column_2">Display Label</td>
										    <td class="detail_view_column_1">
							<div class="detail_view_input" style="display: inline-flex;">
																		<input label="DisplayLabel" type="text" placeholder="Enter DisplayLabel" v-model="nameDetails.displayLabel"></input>
																		</div>
						</td>
														</tr>
															<tr> 
					<td class="detail_view_column_2">Display Label Plural</td>
										    <td class="detail_view_column_1">
							<div class="detail_view_input" style="display: inline-flex;">
																		<input label="DisplayLabelPlural" type="text" placeholder="Enter DisplayLabelPlural" v-model="nameDetails.displayLabelPlural"></input>
																		</div>
						</td>
														</tr>
																				

	
						<tr>
				<td>
					<div>Application Name</div>		
				</td>
				<td  class="detail_view_column_1">
					<div>
					  <div>
						  <vue-autosuggest class="detail_view_input" label="ApplicationName" type="text" placeholder="Enter ApplicationName" v-model="nameDetails.applicationName" :suggestions="filteredSuggestionsApplicationName" :input-props="{id:'autosuggest__inputApplicationName'}" @selected="selectHandlerApplicationName" @input="onInputChangeApplicationName" :getSuggestionValue="s => s.item.applicationName.toString()">
						    <template slot-scope="{ suggestion }">
						      <div>
						        <b>{{suggestion.item.applicationName}}</b>
						      </div>
						    </template>
						  </vue-autosuggest>
					  </div>
					</div>  
				</td>
			</tr>
				
		</table>
	
	




















			<a-tabs v-model:activeKey="activeKey">
											</a-tabs>

		</div>
	</template>

<script>

import NameService from "../services/NameService";
import Modal from "@/components/Modal";
import BaseButton from "@/components/BaseButton";
import BaseInput from "@/components/BaseInput";
import NotificationTemplate from "@/pages/Notifications/NotificationTemplate";
import { Card } from "@/components/Card";
import { ASelect, ASelectOption, AButton, Table, Pagination, message } from "ant-design-vue";
import { VueAutosuggest } from "vue-autosuggest";
import { UploadOutlined } from '@ant-design/icons-vue';
import Datepicker from 'vuejs-datepicker';
import ApplicationTable from "@/components/ApplicationTable";
import ApplicationService from "../services/ApplicationService";


const tableColumns = [];
const tableData = [];
const fileList = ([]);
let file = ({});
const checked = (false);
let yearValue = ('');

export default {
  props: {
    nameId: {
      type: String,
      required: true
    }
  },
  components: {
		Modal,
		BaseButton,
		BaseInput,
		VueAutosuggest,
		UploadOutlined,
		Datepicker,
  },
  data() {
    return {
      nameToAdd: {},
      modal2Names: false,
      nameDetails: null,


      fileList,
      checked,
	  yearValue,



      applicationNameQuery: "",
      suggestionsApplicationName: [],
      suggestionsLoadedApplicationName: false,
    };
  },
  methods: {

    
    selectHandlerApplicationName(item) {
      this.nameDetails.applicationName = item.item.applicationName.toString();
      this.nameDetails.imageFile = item.item.imageFile.toString();
      
    },

    async getApplicationNameSuggestions()
    {
      try {
  		const searchDTO = {
			sortBy: "applicationName", 
			sortOrder: "asc", 
			searchQuery: this.nameDetails.applicationName, 
			page: "0", 
			size: "15"
		};
        let response = await ApplicationService.getAllApplications(searchDTO);
        this.suggestionsApplicationName = response.data.applications;
        this.suggestionsLoadedApplicationName = true;
      } catch (error) {
        console.error('Error fetching applications list for auto-complete: ', error);
      }
    },
    
	onInputChangeApplicationName(text) {
      this.getApplicationNameSuggestions();
    },

	
	handleSwitchChange(lifAnswerId, checked) {
	    this.answers.forEach(function(answer) {
	    	if (answer.questionType == '2') {
		    	if (answer.lifAnswerId == lifAnswerId) {
					answer.answerb = checked;
					if ( checked) {
						answer.answer = "Yes";
					} else {
						answer.answer = "No";
					}
				}
	    	}
		});
	},

 	handlePermissionDialogClose() {
      this.userPermissionDialog = false;
    },

    async handleAddSubmitted() {
      this.modal2Names = false;

      const jsonData = JSON.stringify(this.nameToAdd);
      console.log(jsonData);
      
      const res = await NameService.addName(jsonData);

      if (res.status === 200) {
        this.$notify({
          component: NotificationTemplate,
          icon: "tim-icons icon-bell-55",
          type: "success",
          timeout: 3000,
        });
      }
	},

    async updateName() {

      const jsonData = JSON.stringify(this.nameDetails);
      const res = await NameService.update(jsonData);

      if (res.status === 200) {
//        this.$notify({
//          component: NotificationTemplate,
//          icon: "tim-icons icon-bell-55",
//          type: "success",
//          timeout: 3000,
//        });

//        this.modalNames = false;
//        this.getAllNames();
      }
    },


    async getNameDetails() {
      try {
			let response = await NameService.get(this.nameId);
			this.nameDetails = response.data;

			let hasAnswers = 0;



			if (hasAnswers) {			
		        this.answers.forEach(function(answer) {
		            if (answer.answer === "Yes") {
		               temp = true;
		            } else {
		               temp = false;
		            }
		        });
			}


	    
      } catch (error) {
        console.error('Error fetching name details:', error);
      }
    },
	async updateNameFromSnake() {
		try {
			let response = await NameService.updateNameFromSnake(this.nameDetails.nameId);
			let result = response.data;
		} catch (error) {
			console.error('Error updating name from snake:', error);
		}
	},


	formatTime(dateString) {
      if(dateString !== null){
        const date = new Date(dateString);
      return `${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}-${date.getFullYear()} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')} EST`;
      }
      // Format the date here as needed, for example:
    },  
    
 formatDate(dateString) {
    if (dateString !== null) {
	    const date = new Date(dateString);
	    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
	    const day = String(date.getDate()).padStart(2, '0');
	    const monthAbbreviation = months[date.getMonth()];
	    const year = date.getFullYear();
	    return `${day} ${monthAbbreviation} ${year}`;
  	}
  	// Handle the case when dateString is null or invalid
  	return '';
    
   },

  },
  mounted() {
    this.getNameDetails();
  },
  computed: {
	  filteredSuggestionsApplicationName() {
	    if (!this.suggestionsLoadedApplicationName)
	      return [];
	    this.applicationNameQuery = this.nameDetails.applicationName.toString();
	    return [
	      {
	        data: this.suggestionsApplicationName
	      }
	    ];
	  },
  },
  
};
</script>
<style>

.detail_view_input input {
	text-align: center;
}

.detail_view_column_1 {
	width: 250px; 
	text-align: center;
}
.detail_view_column_2 {
	min-width: 250px; 
}
.input {
	text-align: center;
}
#autosuggest__input {
  display: inline-block;
}
.autosuggest__results-container {
	position: relative;
}
.autosuggest__results {
	font-weight: 300;
	margin: 0;
	position: absolute;
	z-index: 10000001;
	border: 1px solid #e0e0e0;
	border-bottom-left-radius: 4px;
	border-bottom-right-radius: 4px;
	background: white;
}
.autosuggest__results ul {
	list-style: none;
	padding-left: 0;
	margin: 0;
}
.autosuggest__results .autosuggest__results-item {
	cursor: pointer;
	padding: 5px;
}
#autosuggest ul:nth-child(1) > .autosuggest__results_title {
	border-top: none;
}
.autosuggest__results .autosuggest__results_title {
	color: gray;
	font-size: 11px;
	margin-left: 0;
	padding: 15px 13px 5px;
	border-top: 1px solid lightgray;
}
.autosuggest__results .autosuggest__results-item:active,
.autosuggest__results .autosuggest__results-item:hover,
.autosuggest__results .autosuggest__results-item:focus,
.autosuggest__results
.autosuggest__results-item.autosuggest__results-item--highlighted {
	background-color: #F6F6F6;
}

.name-image {
				    	height: 250px;
			}

.inline-item {
  display: inline-block;
  margin-right: 100px; /* Adjust margin as needed */
}

.switch-container {
	width: 215px; 
    text-align: right;
    margin-right: 15px;
    margin-top: 5px;
    margin-bottom: 5px;
}



</style>
